import { render, staticRenderFns } from "./logout_detail.vue?vue&type=template&id=151c398e"
import script from "./logout_detail.vue?vue&type=script&lang=js"
export * from "./logout_detail.vue?vue&type=script&lang=js"
import style0 from "./logout_detail.vue?vue&type=style&index=0&id=151c398e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports